export default "__VITE_ASSET__21d8e7e6__"